import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Button, Badge } from 'reactstrap';
import moment from 'moment';
import Pagination from "react-reactstrap-pagination";
import { toast } from 'react-toastify';
import { api2 } from '~/services/api';
import Loader from '~/components/Loader/Loader';
import PlanSuspensionModal from './create';
import { Container } from './styles';

export default class PlanSuspensions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            suspensions: [],
            loading: true,
            showModal: false,
            selectedSuspension: null,
            selectedPage: 1,
            totalItems: 0,
            perPage: 20,
        };

        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async (page = 1) => {
        this.setState({ loading: true });
        try {
            const { data } = await api2.get(`plan-suspensions?page=${page}&limit=${this.state.perPage}`);
            // Core API usually returns pagination with { data, total, perPage, ... } or just array if not paginated
            // Assuming paginated structure based on Users page
            if (data.data) {
                this.setState({
                    suspensions: data.data,
                    totalItems: data.total,
                    selectedPage: page,
                    loading: false
                });
            } else {
                this.setState({
                    suspensions: data,
                    totalItems: data.length,
                    selectedPage: page,
                    loading: false
                });
            }
        } catch (error) {
            console.error(error);
            toast.error('Erro ao carregar suspensões');
            this.setState({ loading: false });
        }
    };

    handleToggleModal = (suspension = null) => {
        this.setState({
            selectedSuspension: suspension,
            showModal: !this.state.showModal
        });
    };

    handleDelete = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir esta suspensão?')) {
            try {
                await api2.delete(`plan-suspensions/${id}`);
                toast.success('Suspensão excluída com sucesso');
                this.loadData(this.state.selectedPage);
            } catch (error) {
                console.error(error);
                toast.error('Erro ao excluir suspensão');
            }
        }
    }

    getStatusBadge = (status) => {
        switch (status) {
            case 'in_progress': return <Badge color="success">Em progresso</Badge>;
            case 'finished': return <Badge color="info">Finalizado</Badge>;
            default: return <Badge color="secondary">{status || '--'}</Badge>;
        }
    }

    render() {
        const { suspensions, loading, showModal, selectedSuspension, totalItems, perPage, selectedPage } = this.state;

        return (
            <Container>
                {loading && <Loader />}

                <Row>
                    <Col>
                        <div className="page-title-box">
                            <Row>
                                <Col lg={7}>
                                    <h4 className="page-title">Suspensões de planos</h4>
                                </Col>
                                <Col lg={5} className="d-flex justify-content-end align-items-center">
                                    <Button color="success" onClick={() => this.handleToggleModal()}>
                                        Nova Suspensão
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card style={{ overflow: 'auto' }}>
                            <CardBody>
                                <table className="table table-centered table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Usuário</th>
                                            <th>Email</th>
                                            <th>Treinador</th>
                                            <th>Status</th>
                                            <th>Início</th>
                                            <th>Fim</th>
                                            <th>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {suspensions.map(s => (
                                            <tr key={s.id}>
                                                <td>{s.id}</td>
                                                <td>{s.user?.name}</td>
                                                <td>{s.user?.email}</td>
                                                <td>{s.user?.coach?.name}</td>
                                                <td>{this.getStatusBadge(s.status)}</td>
                                                <td>{moment(s.start_at).format('DD/MM/YYYY')}</td>
                                                <td>{moment(s.end_at).format('DD/MM/YYYY')}</td>
                                                <td>
                                                    <Button color="primary" size="sm" className="mr-2" onClick={() => this.handleToggleModal(s)}>
                                                        Editar
                                                    </Button>
                                                    <Button color="danger" size="sm" onClick={() => this.handleDelete(s.id)}>
                                                        Excluir
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                        {suspensions.length === 0 && !loading && (
                                            <tr>
                                                <td colSpan="9" className="text-center">Nenhuma suspensão encontrada</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {totalItems > perPage && (
                    <Row>
                        <Col xs={12} className="d-flex justify-content-center">
                            <Pagination
                                firstPageText="Início"
                                lastPageText="Fim"
                                previousPageText="Anterior"
                                nextPageText="Próximo"
                                totalItems={totalItems}
                                pageSize={perPage}
                                activePage={selectedPage}
                                onSelect={this.loadData}
                            />
                        </Col>
                    </Row>
                )}

                {showModal && (
                    <PlanSuspensionModal
                        open={showModal}
                        toggle={() => this.handleToggleModal()}
                        suspension={selectedSuspension}
                        loadData={() => this.loadData(selectedPage)}
                    />
                )}
            </Container>
        );
    }
}
